export const BASE_URL = process.env.REACT_APP_API_URL;
export const API_KEY = process.env.X_API_KEY;
export const TOKEN = "0xf811Aa4850e034755cC33601fEb139130c908584";    ///.  sepolia soli coin address    // "0xcb5c8D072C5760148c5d6AD7D78154E8EB74C3E2"; //
export const AIRDROP_CONTRACT_ADDRESS =
  "0xdA4D675bc03f7f6Aba91aa2b89cB0db0641Fc71E";   // sepolia airdrop contract //    // 0xfC7B0d3BF5Ee8eEfd4fd8688cc244e8d0d964B9a. 
export const ICO_CONTRACT_ADDRESS =
  "0xe202a733C3827d2D19F540F3a33a79C6201F89dc";   ////.   sepolia ico contract  address             ///. 0xFc27fFB99AF4cE05A366655401a87a9409186dE0
// "0xCf1A66da4dDBccee1CfC335E6f6dA64EC03b3B7f";

export const DAO_CONTRACT_ADDRESS =
  "0x5df5e16f427b111424275ae1b5D37Ad7f572276e";      ///. Sepolia Dao contrat  addresss   ////. 0x26620AfaC82aE84794761f130ee2a99580F8d847

// "0xf7E3B1062262A50Ae414A75d6F7bBC609f4eb3B9";
export const USDT_CONTRACT_ADDRESS =
  "0x6C4c04E4b8FC97B7af41D3Fe6B6c379E7B474F80";    ///  sepolia usdt contract address           ///  0x6c7C3a77F90C6947498297642E135D50EfC61c06
export const STANDARD_IMAGE_URL =
  "https://wow-dash.com/demo/assets/images/user-grid/user-grid-bg1.png";

export const AIRDROP_STATUS = Object.freeze({
  PENDING: "pending",
  SUCCESS: "success",
  FAILED: "failed",
});          
